function getPageUrl() {
	let url = window.location.href;
	
	// Strip any anchors
	url = -1 === url.indexOf('#') ? url : url.substr( 0, url.indexOf('#') );

	return url;
}

/**
 * Get the query parameters, or a named one, from any passed URL.
 * @param  {String} url   A full URL with query parameters.
 * @param  {String} name  Optional, The name of the query parameter.
 *                        Leave blank to return all parsed parameters.
 * @return {Array|String} If name is passed:
 *                           The query parameter if it is set,
 *                           		Array for multiple values with same key,
 *                           		String for single values
 *                           false otherwise
 *                        Else
 *                       		 The full parsed GET array if any params are set,
 *                       		 or a blank array if there are none.
 */
function getQueryArg( url, name = null ) {
	if ( -1 === url.indexOf('?') ) {
		return name ? false : [];
	}

	// Strip any anchors
	url = -1 === url.indexOf('#') ? url : url.substr( 0, url.indexOf('#') );

	const GET = ( () => { 
		let qd = {};
		/**
		 * Split the url on the query string start '?', 
		 * then split 2nd part i.e. the query string into each parameter.
		 * For each parameter, parse the values and fill qd with found keys & values.
		 * 
		 * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript/21152762#21152762
		 * - Slightly modified to work for any URL string
		 */
		url.split('?')[1].split(`&`).forEach( item => {
			const _split = item.split('=');
			let k = _split[0] && decodeURIComponent( _split[0] );
			const v = _split[1] && decodeURIComponent( _split[1] );

			// If k denotes a nested value strip the array index
			// E.g. foo[0], foo[1] => foo
			let matches = k.match( /(.*)\[(\d)+\]$/ );
			if ( matches && '' !== matches[0] ) {
				k = matches[1];
			}

			( qd[k] = qd[k] || [] ).push(v); 
		} );
		return qd;
	} )();

	if ( name ) {
		if ( GET[name] && GET[name].length > 1 ) {
			return GET[name];
		} else if ( GET[name] ) {
			return GET[name][0];
		} else {
			return false;
		}
	} else {
		return GET;
	}
}


/**
 * Add a query arg to the src attribute on an oEmbed item.
 * This function does not support adding multiple args.
 * @param  {string} key   The query arg name.
 * @param  {string} value The query arg value.
 * @param  {string} url   Optional, The base URL. Defaults to document.location.
 * @return string         The URL with the query arg added.
 */
function addQueryArg( key, value, url = null ) {
	if ( !url ) {
		url = document.location.href;
	}

	// Check for an existing query string
	let queryStringPos = url.indexOf('?');

	if ( queryStringPos == -1 ) {
		return url + `?${key}=${value}`;
	}

	let queryString = url.substr( queryStringPos + 1 ).split('&');
	let queryStringKeys = queryString.map( arg => arg.split('=')[0] );

	// Check for an existing key value
	let keyPosition = queryStringKeys.indexOf( key );

	if ( keyPosition == -1 ) {
		return url + `&${key}=${value}`;
	}

	// At this point we know there is an existing query string containing the key.
	// Replace the existing key's value with the new value.
	queryString[ keyPosition ] = `${key}=${value}`;

	// Rebuild the full URL
	return url.substr( 0, queryStringPos + 1 ) + queryString.join('&');
}

/**
 * A multiple args version of the above function.
 * @param {Object} args An object with { key: value } pairs of args.
 * @param {String} url  The URL with the query args added.
 */
function addQueryArgs( args, url = null ) {
	if ( !url ) {
		url = document.location.href;
	}

	// Iterate args properties
	let keys = Object.keys( args ), len = keys.length;
	for (let i = 0; i < len; i++) {
		url = addQueryArg( keys[i], args[ keys[i] ], url );
	}

	return url;
}
